export enum SmartSuggestionCustomAction {
  QUICK_WALK_MODAL = '#quickWalkModal',
}
